import { WhatsappMessage } from '@common-components/whatsapp-message';
import { Stack } from '@mui/material';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { selectMessagesForCurrentChat } from '@common-reducers/UserSelectors';
import { useRef } from 'react';
import ScheduledMessagesEmptyState from '../scheduled-contact-list/scheduledMessagesEmptyState';
import { UserMessage } from '@bt-common/schemas/bt/user-message';

interface ChatMessagesProps {
    filteredMessages?: UserMessage[];
}

export default function ChatMessages({ filteredMessages }: ChatMessagesProps = {} as ChatMessagesProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const defaultMessageList = useAppSelector(selectMessagesForCurrentChat);
    
    // Use filteredMessages if provided, otherwise use default selector
    const messageList = filteredMessages !== undefined ? filteredMessages : defaultMessageList;

    return (
        <Stack ref={containerRef} spacing={1}>
            {messageList.length > 0 ? (
                messageList.map((message, index) => <WhatsappMessage key={message._id || index} messageId={message._id} />)
            ) : (
                <ScheduledMessagesEmptyState />
            )}
        </Stack>
    )
}